<!--打开App  -->
<template>
  <div class="open-app" v-show="show">
    <img class="close" @click="show=false" src="../../../assets/img/footer/close.png" alt="" />
    <section class="bottomArea">
      <p class="companyName"></p>
      <div class="appInfo">
        <p class="appName">打开启航教育APP</p>
        <p class="appDescription">听课更流畅</p>
      </div>
      <button @click="goApp" class="goApp">前往APP</button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show:true
    };
  },

  components: {},

  computed: {},

  mounted() {},

  created() {},
  methods: {
    goApp() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'https://itunes.apple.com/cn/app/id1172161344';
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      } else {
        const loadDateTime = Date.now();
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'iqihanglmh5://';
          const turnIOS = setTimeout(() => {
            const timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 2200) {
              window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
            } else {
              clearTimeout(turnIOS);
            }
          }, 2000);
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.open-app {
  position: fixed;
  bottom: 17%;
  left: 0;
  z-index: 98;
  width: 100%;
  height: 148px;

  .close {
    position: absolute;
    top: -28px;
    left: 36px;
    z-index: 1000;
    width: 40px;
    height: 40px;

  }
}
.bottomArea {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  display: flex;
  align-items: center;
  width: 648px;
  height: 148px;
  margin: 0 auto;
  background: #fefffe;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

  .companyName {
    width: 84px;
    height: 84px;
    margin: 0 22px 0 48px;
    background: url('../../../assets/img/footer/logo.png') no-repeat center center;
    background-size: contain;
  }

  .appInfo {
    .appName {
      height: 36px;
      margin-bottom: 7px;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
    }

    .appDescription {
      height: 31px;
      color: #787878;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
  }

  .goApp {
    position: absolute;
    top: 40px;
    right: 88px;
    height: 67px;
    padding: 0 16px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 67px;
    text-align: center;
    background: #ff6c02;
    border-radius: 34px;
    cursor: pointer;

    &:active {
      background: #ff984d;
    }
  }
}
</style>
